import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {Link} from 'react-router-dom';
import {Breadcrumb, Container, Statistic, Grid} from 'semantic-ui-react';

import CustomDivider from '../../components/extras/CustomDivider';
import DynamicTable from "../../components/extras/DynamicTable";
import SaleData from "../../data/SaleData";
import Loading from "../../components/extras/Loading";
import {FormattedNumber} from "react-intl";

class OutstandingBalances extends Component {
    constructor() {
        super();
        this.state = {
            table_balances: {
                headers: ['Nº', 'Cliente', 'Total Venta', 'Descuento', 'Pagos', 'Saldo Pendiente'],
                name: 'Venta',
                title: 'Saldos Pendientes',
                has_actions: false,
                navigate: false,
                pagination: true,
                url: 'sales/balances',
                values: ['id', 'billing_number', 'client', 'total_sum', 'discount', 'payments_sum', 'balance'],
                id: 'table_balances',
                money_fields: ['total_sum', 'payments_sum', 'balance', 'discount'],
            },
            total: 0,
            loading: true
        }
    }

    componentWillMount() {
        SaleData.getTotalBalance().then(total_balance =>{
            this.setState({total:total_balance[0].balance});
        }).catch(() => this.setState({total:0})).finally(() => this.setState({loading:false}));
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Bisttros - Saldos Pendientes</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/sales'>Finanzas</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Saldos Pendientes</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                {
                    this.state.loading ? <div style={{paddingBottom:'3em'}}><Loading/></div>:
                        <div>
                        <Container textAlign='center'>
                            <Statistic>
                                <Statistic.Value>
                                    $<FormattedNumber value={this.state.total} currency="USD" maximumFractionDigits={0} minimumFractionDigits={0}/>
                                </Statistic.Value>
                                <Statistic.Label>Total Saldos Pendientes</Statistic.Label>
                            </Statistic>
                            <br/>
                        </Container>
                        <Grid stackable>
                            <Grid.Row columns={1}>
                                <Grid.Column>
                                    <DynamicTable {...this.state.table_balances} />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </div>
                }
            </div>
        );
    }
}

export default OutstandingBalances;



// WEBPACK FOOTER //
// ./src/containers/sales/OutstandingBalances.js